export enum Errors {
    CallFailed = 'callFailed',
    SessionInfoCallFailed = 'sessionInfo',
    Unauthorized = '401'
}